// ServiceCard.tsx
import type { Services } from "../data/Services";

type CardProps = {
  section: Services;
};

const ServiceCard: React.FC<CardProps> = ({ section }) => {
  return (
    <>
      <style>{`
        .sb-card {
          background: rgba(255, 255, 255, 0.95);
          border: 0.5px solid rgba(0, 0, 0, 0.08);
          border-radius: 12px;
          overflow: hidden;
          box-shadow: 0 1px 24px rgba(0, 0, 0, 0.06);
          display: flex;
          flex-direction: column;
          height: 100%;
          transition: box-shadow 0.2s ease, transform 0.2s ease;
        }

        .sb-card:hover {
          box-shadow: 0 6px 32px rgba(38, 55, 82, 0.12);
          transform: translateY(-2px);
        }

        .sb-card-body {
          display: flex;
          flex-direction: column;
          padding: 1.75rem;
          gap: 1rem;
          flex: 1;
        }

        .sb-card-icon {
          width: 44px;
          height: 44px;
          background: rgba(38, 55, 82, 0.07);
          border-radius: 10px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .sb-card-icon svg {
          width: 22px;
          height: 22px;
          stroke: #263752;
          fill: none;
          stroke-width: 1.75;
          stroke-linecap: round;
          stroke-linejoin: round;
        }

        .sb-card-title {
          font-family: 'Noto Serif JP', serif;
          font-size: 1.05rem;
          font-weight: 700;
          color: #263752;
          letter-spacing: -0.01em;
          margin: 0;
        }

        .sb-card-description {
          font-family: 'DM Sans', sans-serif;
          font-size: 0.875rem;
          color: #6b7280;
          margin: 0;
          line-height: 1.7;
        }
      `}</style>

      <article className="sb-card">
        <div className="sb-card-body">
          <div className="sb-card-icon">
            {section.icon}
          </div>
          <h3 className="sb-card-title">{section.title}</h3>
          <p className="sb-card-description">{section.description}</p>
        </div>
      </article>
    </>
  );
};

export default ServiceCard;